<template>
  <div :class="{'tab-nav': true, 'colored': coloredBackground}">
    <nobr v-if="!breakable">
      <router-link
        v-if="!noRoute && !tab.dissabled"
        :class="getRouteClass(tab.name)"
        v-for="tab in tabs"
        :key="tab.name"
        :to="{name: tab.route, params: tab.params}">

        {{ $t(tab.label) }}
      </router-link>

      <div
        v-else
        :class="getRouteClass(tab.name)"
        v-for="tab in tabs"
        :key="tab.name">

        <p
          :class="getTabClassP(tab, active)"
          @click="tabChange(tab.route)">

          {{ $t(tab.label) }}
        </p>
      </div>
    </nobr>

    <div
      class="text-center text-md-left"
      v-if="breakable">

      <router-link
        v-if="!noRoute && !tab.dissabled"
        :class="getRouteClass(tab.name)"
        v-for="tab in tabs"
        :key="tab.name"
        :to="{name: tab.route}">

        {{ $t(tab.label) }}
      </router-link>

      <div
        v-else
        :class="getRouteClass(tab.name)"
        v-for="tab in tabs"
        :key="tab.name">

        <p
          :class="getTabClassP(tab, active)"
          @click="tabChange(tab.route)">

          {{ $t(tab.label) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    getTabClassP (tab, active) {
      let base = 'm-0'
      base += (tab.dissabled) ? ' dissabled' : ' enabled'
      return base
    },
    tabChange (data) {
      this.$emit('tabChange', {data})
    },
    getRouteClass (tabName) {
      let base = `tab-route`

      if (this.btnStyle) {
        base = `${base} button-tab-style`
      } else {
        base = `${base} normal`
      }

      if (tabName == this.active) {
        base += ' active'
      }

      return base
    }
  },
  props: {
    btnStyle: {
      type: Boolean,
      required: false,
      default: false
    },
    noRoute: {
      type: Boolean,
      required: false,
      default: false
    },
    tabs: {
      type: Array,
      required: true,
      default: () => []
    },
    active: {
      type: String,
      required: false
    },
    breakable: {
      type: Boolean,
      required: false,
      default: false
    },
    coloredBackground: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style scoped>
.tab-nav {
  overflow-x: scroll;
}
.tab-nav.colored {
  background-color: #FFFFFF;
}

.tab-nav::-webkit-scrollbar { 
    display: none; 
}
.tab-route {
  display: inline-block;
  background-color: #ffffff;
}
.tab-route, .tab-route p {
  color: #353635;
  transition: color .3s;
  font-size: 13px;
  line-height: 16px;
}

.normal {
  height: 50px;
  border-bottom: 2px solid #ffffff;
  padding: 12px 0;
  margin-right: 15px;
  transition: border-bottom .3s;
}
.normal:last-child {
  margin: none;
}

.normal.active {
  border-bottom: 2px solid #7AC143;
}

.normal.active, .normal.active p {
  color: #7AC143;
}

.enabled {
  cursor: pointer;
}
.dissabled {
  cursor: default;
}


.button-tab-style {
  background-color: #66A237;
  color: #FFFFFF;
  padding: 11px 30px 14px 30px;
  border-radius: 40px;
  margin: 7px 16px 7px 0;
  font-size: 16px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  transition: color .3s, background-color .3s, border .3s, box-shadow .3s;
}
.box-style {
  background-color: #F8F8F8;
  border: 1px solid #D2D3D4;
  border-radius: 0;
  margin-left: 0;
  transition: background-color .3s;
}
.box-style p {
  color: #000000;
}

.box-style.active {
  background-color: #FFF;
}
.link-tab-style.active {
  /* border-bottom: 2px solid #7AC143; */
  background-color: #7AC143;
  color: #FFF;
  padding: 0;
  /*margin: 17px 9px 0px 19px;*/
  padding-bottom: 15px;
  transition: color .3s;
  border-bottom: 2px solid #FFF;
  transition: border-bottom .3s;
}
.button-tab-style.active {
  background-color: #7AC143;
  box-shadow: none;
}
.button-tab-style.active a {
  color: #FFF;
}
.tab-style {
  background-color: transparent;
}
.tab-style a, .tab-style p {
  color: #E3E3E3;
  font-weight: bold;
  transition: color .3s;
  font-weight: bold;
}
.tab-style .active {
  color: #353635;
}

</style>



// WEBPACK FOOTER //
// src/components/standard/action/TabNav.vue?bf8fb62c